import DEFINE, { PATHS } from './../constants/Define';

export default [{
    title: "orders",
    tagSub: "orders",
    exact: false,
    path: PATHS.ORDER.path,
    icon: 'snippets',
    show: true,
    isParrentMenu: true,
    routeName: DEFINE.GENERAL.ROUTE_NAME.ORDER_MANAGEMENT,
    permissions: [DEFINE.GENERAL.PERMISSION.VIEW],
    children: [
        {
            title: "orders",
            group: "orders",
            path: PATHS.ORDER.LIST.path,
            tagSub: "orders",
            exact: false,
            icon: 'snippets',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.ORDER,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, 
                DEFINE.GENERAL.PERMISSION.UPDATE, 
                DEFINE.GENERAL.PERMISSION.SALE_ORDER, 
                DEFINE.GENERAL.PERMISSION.RESEND_EMAIL, 
                DEFINE.GENERAL.PERMISSION.EXPORT_VOUCHER, 
                DEFINE.GENERAL.PERMISSION.EXPORT_FILE_ORDER,
                DEFINE.GENERAL.PERMISSION.EXPORT_EXCLUDE_USER_INFO,
                DEFINE.GENERAL.PERMISSION.UPDATE_ITEM_STATUS,
                DEFINE.GENERAL.PERMISSION.ACCOUNTANT_STATUS,
                DEFINE.GENERAL.PERMISSION.LOCK_ITEM,
                DEFINE.GENERAL.PERMISSION.RECOMMIT,
                DEFINE.GENERAL.PERMISSION.UPDATE_STATUS,
                DEFINE.GENERAL.PERMISSION.CHANGE_RATECODE,
                DEFINE.GENERAL.PERMISSION.REFUND,
            ],
            children: [
                {
                    title: "orderDetail",
                    group: "orders",
                    tagSub: "orders",
                    path: PATHS.ORDER.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "flightTracking",
            group: "flightTracking",
            exact: false,
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.FLIGHT_TRACKING,
            permissions: [
                DEFINE.GENERAL.PERMISSION.VIEW, 
                DEFINE.GENERAL.PERMISSION.UPDATE, 
                DEFINE.GENERAL.PERMISSION.DELETE,
                DEFINE.GENERAL.PERMISSION.CREATE
            ]
        },
        {
            title: "tickets",
            group: "tickets",
            path: PATHS.TICKET.LIST.path,
            tagSub: "orders",
            exact: false,
            icon: 'faTicketAlt',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
            children: [
                {
                    title: "updateTickets",
                    group: "tickets",
                    tagSub: "orders",
                    path: PATHS.TICKET.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "myTickets",
            group: "myTickets",
            path: PATHS.TICKET.MY_TICKET.path,
            tagSub: "orders",
            exact: false,
            icon: 'faColumns',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.MY_TICKET,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.UPDATE],
        },
        {
            title: "ticketAssignConfigs",
            group: "ticketAssignConfigs",
            path: PATHS.TICKET_ASSIGN_CONFIG.LIST.path,
            tagSub: "orders",
            exact: false,
            icon: 'faCalendarWeek',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.TICKET_ASSIGN_CONFIG,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createTicketAssignConfigs",
                    group: "ticketAssignConfigs",
                    tagSub: "orders",
                    path: PATHS.TICKET_ASSIGN_CONFIG.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                },
                {
                    title: "updateTicketAssignConfigs",
                    group: "ticketAssignConfigs",
                    tagSub: "orders",
                    path: PATHS.TICKET_ASSIGN_CONFIG.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "emailTemplate",
            group: "emailTemplate",
            path: PATHS.EMAIL_TEMPLATE.LIST.path,
            tagSub: "orders",
            exact: false,
            icon: 'faMailBulk',
            show: true,
            routeName: DEFINE.GENERAL.ROUTE_NAME.EMAIL_TEMPLATE,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
            children: [
                {
                    title: "createEmailTemplate",
                    group: "emailTemplate",
                    tagSub: "orders",
                    path: PATHS.EMAIL_TEMPLATE.CREATE.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                },
                {
                    title: "updateEmailTemplate",
                    group: "emailTemplate",
                    tagSub: "orders",
                    path: PATHS.EMAIL_TEMPLATE.DETAIL.path,
                    exact: false,
                    icon: 'user',
                    show: false,
                }
            ]
        },
        {
            title: "surcharge",
            group: "surcharge",
            path: '/',
            tagSub: "orders",
            exact: false,
            icon: 'faMailBulk',
            show: false,
            routeName: DEFINE.GENERAL.ROUTE_NAME.SURCHARGES,
            permissions: [DEFINE.GENERAL.PERMISSION.VIEW, DEFINE.GENERAL.PERMISSION.CREATE, DEFINE.GENERAL.PERMISSION.UPDATE, DEFINE.GENERAL.PERMISSION.DELETE],
        },
    ]
}]
